"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gmailRemoveLabelFromEmail = exports.gmailRemoveLabelFromEmailResultSchema = exports.gmailRemoveLabelFromEmailArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.gmailRemoveLabelFromEmailArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('remove-label-from-email', zod_1.z.object({
    message: zod_1.z.string().describe('The ID of the message to modify'),
    removeLabelIds: zod_1.z.array(zod_1.z.string()).describe('The labels to remove from the email'),
}));
exports.gmailRemoveLabelFromEmailResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.object({
    id: zod_1.z.string().describe('The immutable ID of this message'),
    threadId: zod_1.z.string().describe('The ID of the thread the message belongs to'),
    labelIds: zod_1.z.array(zod_1.z.string()).describe('List of label IDs applied to this message'),
    snippet: zod_1.z.string().nullish().describe('A short part of the message text'),
}));
exports.gmailRemoveLabelFromEmail = (0, common_1.createToolMetadata)({
    id: 'gmailRemoveLabelFromEmail',
    displayName: 'Gmail Remove Label from Email',
    displayDescription: 'Remove label(s) from an email message in Gmail',
    category: 'communication',
    color: common_1.BRAND_COLORS.GMAIL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GMAIL),
    icon: 'gmail',
    argsSchema: exports.gmailRemoveLabelFromEmailArgsSchema,
}, exports.gmailRemoveLabelFromEmailResultSchema);
